import React from 'react';
import './styles.scss';

const VideoEmbed = ({ videoSrc, title, width = "100%", height = "100%" }) => (
    <div className="VideoEmbed-container">
        <iframe
            title={title}
            src={videoSrc}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; clipboard-write; web-share"
            width={width}
            height={height}
            allowFullScreen
        />
    </div>
)

export default VideoEmbed;